import React, { useEffect, useState } from "react";
import { Container, Table, Row, Col } from "react-bootstrap";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import { config } from "../../../CommonUtils/CommonUrl/CommonUrls";
import Header from "../../../Header/Header";
import { CommonAxiosGet } from "../../../CommonUtils/CommonAxios/CommonAxios";

export default function ACLReport() {
  let navigate = useNavigate();
  const location = useLocation();
  const Data = location?.state?.data;
  const [AclData, setAclData] = useState([]);
  function AclGetData() {
    const URLL = config.url.BOC_URL + "acls/" +Data?.distcode;
  CommonAxiosGet(URLL).then((res) => {
      if (res?.data.status === true) {
        setAclData(res?.data.acls);
      }
    });
  }
  function alertMessage() {
    Swal.fire({
      text: "No Data Found",
      icon: "info",
      confirmButtonColor: "#3085d6",    
      confirmButtonText: "OK",
    }).then((willDelete) => {
      if (willDelete.isConfirmed) {
      }
    });
  }
  useEffect(() => {
    AclGetData();
  }, []);
  return (
    <>
      <Header />
      <div className="main_section"> </div>
    
          <Container>
            <Row>
              <Col
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                xxl={12}
                className="page-titlespacing d-flex justify-content-between"
              >
                <div className="inner-herbpage-service-title1">
                  <h1>
                  <span style={{color:"brown"}}> {Data?.distname}</span> -  ACL Wise Mapping
                    Report
                  </h1>
                </div>
                <div className="text-right">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={()=>{ navigate(-1)}}
                  >
                    Back
                  </button>
                </div>
              </Col>
            </Row>
          </Container>
          <Container className="outer-page-content-container">
            <Row className="px-4">
              <Table className="table table-condensed table-bordered table-striped table-responsive table-hover mt-3 mb-5 tableex">
            <thead>
                  <tr>
                    <th>S.No</th>
                    <th>ACL Name</th>
                    <th>No Of ALO</th>
                    <th> No Of Mandals Mapped</th>
                  </tr>
                </thead>
                <tbody>
                  {AclData &&
                    AclData?.map((data, i) => {
                      return (
                        <tr key={i}>
                          <td style={{ textAlign: "center" }}>{i + 1}</td>

                          <td>{data?.org_name}</td>
                          <td style={{ textAlign: "center", color: "Highlight", textDecoration: "underline" }}
                              onClick={() => { data.mapped_mandals !== 0
                                 ? navigate("/ACLMappedReport",{state : {data:data}}) 
                                 : alertMessage()
                              }}>
                          
                              {data.acl_count}
                           
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {data.no_of_mandals_mapped}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            </Row>
          </Container>
    </>
  );
}
